const Moment = require("moment");
const momentTZ = require("moment-timezone");

const DEFAULT_TIMEZONE = "Asia/Riyadh";
// const DEFAULT_TIMEZONE_OFFSET = '+03:00';

/**
 * Format given date
 * @param {*} date
 * @param {*} dateFormat
 */
function format(date, dateFormat) {
  if (!dateFormat) {
    dateFormat = "YYYY-MM-DD";
  }

  return Moment(date).format(dateFormat);
}

/**
 * Format given date
 * @param {*} date
 * @param {*} dateFormat
 * @param {*} timezone
 */
function formatTZ(date, dateFormat, timezone, skipTimeZone) {
  if (!dateFormat) {
    dateFormat = "YYYY-MM-DD";
  }
  if (!timezone) {
    timezone = DEFAULT_TIMEZONE;
  }

  if (skipTimeZone) {
    return Moment(date).format(dateFormat);
  }

  return momentTZ.tz(date, timezone).format(dateFormat);
}

/**
 * Get tomorrow's date
 */
function getTomorrow() {
  return Moment().add(1, 'days').toDate();
}

module.exports = {
  format,
  formatTZ,
  getTomorrow
};
